import React from 'react';
import { motion } from 'framer-motion';
import { Award, Heart, Leaf, Shield } from 'lucide-react';

export const About = () => {
  return (
    <div className="min-h-screen py-16">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="font-serif text-5xl sm:text-6xl font-bold text-foreground mb-6">
            About NaturalCare
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Your trusted partner in natural wellness, providing premium cosmetics and pharmaceutical products since 2020.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-elegant">
              <img
                src="https://images.unsplash.com/photo-1580870069867-74c57ee1bb07?w=1200&q=85"
                alt="Natural skincare products"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif text-4xl font-bold text-foreground mb-6">
              Our Story
            </h2>
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
              Founded with a vision to make natural wellness accessible to everyone, NaturalCare has grown into a trusted destination for premium cosmetics and pharmaceutical products.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              We carefully curate our selection, partnering only with brands that share our commitment to quality, safety, and the power of natural ingredients.
            </p>
          </motion.div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {[
            { icon: Leaf, title: 'Natural Ingredients', description: 'Only the finest natural and organic ingredients' },
            { icon: Shield, title: 'Quality Assured', description: 'All products thoroughly tested and certified' },
            { icon: Heart, title: 'Customer First', description: 'Your satisfaction is our top priority' },
            { icon: Award, title: 'Expert Selection', description: 'Curated by wellness professionals' }
          ].map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <item.icon className="w-8 h-8 text-primary" />
              </div>
              <h3 className="font-semibold text-lg mb-2">{item.title}</h3>
              <p className="text-muted-foreground">{item.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-hero rounded-3xl p-12 text-center"
        >
          <h2 className="font-serif text-4xl font-bold text-foreground mb-6">
            Join Our Wellness Journey
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Experience the difference that natural, quality products can make in your life. Start your wellness journey with NaturalCare today.
          </p>
        </motion.div>
      </div>
    </div>
  );
};